import { useEffect, useState } from 'react';
import automobile from '../img/automobile.png';

export default function StickyFooter() {

    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
        setScroll(window.scrollY > 250)
        })
    }, []);

    return <>
        <div className={`stickyFooter ${scroll ? 'active':''}`} >
            <div id="sticky_footer">
                <div class="container"><div>
                    <div class="d-flex justify-content-center align-content-center text-center">
                        <div class="titleImage" >
                            <img alt="vehicle" src={automobile} class="img-fluid" />
                        </div>
                        <div class="titleDisc px-4">
                            <h3 >20% OFF</h3>
                            <small class="text-uppercase" >Car Shipping</small>
                        </div>
                        <div class="stickBtns">
                            <a href="#" class="btn btn-primary mx-2" >Get My Free Quote Now </a>
                            <a href="#" class="btn btn-dark mx-2" >Call Us  1-800-452-2880 </a>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </>
}